import React, { useState} from "react";

import Api from "../baseApi";
import {useTunnelData} from "../TunnelContext";
import {useAnalytics} from "../analytics";
import Button from "../Button";
import LabelInputText from '../LabelInputText'
import {useConfig} from '../ConfigProvider';

import "./Plans.scss";
import { getErrorMessage } from "../utils/getErrorMessage";

export default function PromoCode() {
  const {tunnel, setTunnel} = useTunnelData();
  const {trackPromoCodeApplied, trackPromoCodeError} = useAnalytics();
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const config = useConfig();

  const handleCodeChange = (e) => {
    setError(null);
    setCode(e.target.value.trim().toUpperCase());
  };

  const handleError = (err) => {
    const errorMessage = getErrorMessage(config, err);
    console.error(errorMessage);
    setError(errorMessage);
    trackPromoCodeError(code, errorMessage);
    setLoading(false);
  };

  const verifyPromoCode = async () => {
    const [query] = Api.GET({
      path: `/api/vel/resamania2/promo/${code}`,
      query: { msdsId: tunnel.club.msdsId}
    });
    return query;
  };

  const applyPromoCode = async () => {
    const [query] = Api.POST({
      path: `/api/vel/resamania2/promo/${code}`,
      body: {
        saleId: tunnel.sales['@id'],
        msdsId: tunnel.club.msdsId,
        tunnelUid: tunnel.uid
      }
    });
    return query;
  };

  const refreshSalesData = async () => {
    const [query] = Api.GET({
      path: `/api/vel/resamania2/sales`,
      query: {
        msdsId: tunnel.club.msdsId,
        saleId: tunnel.sales['@id'],
        tunnelUid: tunnel.uid
      }
    });
    const result = await query;
    // Mettre à jour les données de vente dans le tunnel
    if (result && result.sale) {
      setTunnel({ ...tunnel, sales: result.sale });
    }
    return result;
  };

  const handleSubmit = async () => {
    setError(null);
    setLoading(true);

    try {
      // 1. Vérifier que le code promo est valide
      // lève une exception si le code n'est pas valide ou expiré
      await verifyPromoCode();

      // 2. Appliquer le code promo à la vente
      // idem : exception si le code ne peut pas être appliqué (il y est déjà...)
      await applyPromoCode();

      // 3. Rafraîchir les données de vente (qui met à jour le tunnel)
      await refreshSalesData();

      trackPromoCodeApplied(code);
      setLoading(false);
    }
    catch (err) {
      handleError(err);
    }
  };
  // Si un code promo est déjà appliqué (présent dans les sales), afficher uniquement le code
  const hasPromoCode = tunnel.sales?.saleSpecialOfferCodes?.length > 0;

  if (hasPromoCode) {
    return (
      <aside className='PromoCode'>
        <h4>Code promo appliqué</h4>
        <p style={{ color: 'green', fontWeight: 'bold' }}>✓ Réduction active</p>
      </aside>
    );
  }

  // Formulaire pour saisir un nouveau code promo
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
      className='PromoCode'
    >
      <h4>{config.promoCode.label}</h4>
      <div style={{ alignItems: 'baseline' }}>
        <LabelInputText
          onChange={handleCodeChange}
          name="promoCode"
          placeHolder={config.promoCode.placeholder}
          value={code}
        />
        <Button
          disabled={loading || !code.length}
          onClick={handleSubmit}
          type="submit"
          style={{ marginBottom: '1rem' }}
        >
          {loading ? config.promoCode.verifyingLabel : config.promoCode.confirmLabel}
        </Button>
      </div>
      {error && (
        <p style={{ color: "red" }} className="PromoCodeError">
          {error}
        </p>
      )}
    </form>
  );
}
